export default __webpack_public_path__ + "static/cohorts-page-light-mode-c8c1deeb260ae09e8c0e22144a5bf960.png";